import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  CONFIRM_ACCEPT_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  REASON_TEXT
} from "../../constants/otherTexts";
import { Modal } from "../../components/modal";
import { PettyCashAction } from "../../actions";
import { Container } from "./style";
import ExpandHeightTextarea from "../../components/expandHeightTextarea";
import { reasonForRejectPettyCashLength } from "../../constants/maxLenghtAtrribute";

const Index = props => {
  const {
    show,
    processing,
    data: { title, reasonObject },
    closeModal,
    submitReason
  } = props;
  const [description, changeDescription] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      changeDescription("");
      document.body.style.overflow = "auto";
    };
  }, [show]);
  const submit = () => {
    if (
      ("requireDescription" in reasonObject &&
        !reasonObject.requireDescription) ||
      description
    ) {
      submitReason({ description: description }, reasonObject.id);
    } else {
      setError("وارد کردن توضیحات الزامی است.");
    }
  };
  return (
    <Modal
      show={show}
      loading={processing}
      height={"55vh"}
      closeHandler={() => closeModal()}
      header={{
        title: title
      }}
      footer={{
        buttons: [
          {
            buttonType: "primary",
            clickHandler: () => submit(),
            buttonText: CONFIRM_ACCEPT_BUTTON_TEXT,
            useLoading: true
          },
          {
            buttonType: "secondary",
            clickHandler: () => closeModal(),
            buttonText: CONFIRM_REJECT_BUTTON_TEXT
          }
        ]
      }}
    >
      <Container>
        <div className="extra-note">{REASON_TEXT(reasonObject)}</div>

        <ExpandHeightTextarea
          padding={"10px"}
          input={{
            name: "description",
            value: description,
            onChange: value => {
              changeDescription(value);
              setError("");
            }
          }}
          maxLength={reasonForRejectPettyCashLength}
          meta={{ error: error }}
          status="normal"
          placeholder="توضیحات..."
        />
      </Container>
    </Modal>
  );
};

const mapStateToProps = store => {
  return {
    show: store.PettyCash.modalStatus,
    data: store.PettyCash.modalData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => dispatch(PettyCashAction.reasonCloseModal())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
